document.addEventListener('DOMContentLoaded', () => {
    const stickyNav = document.querySelector('.sticky-nav');
    const sentinel = document.querySelector('.sticky-sentinel');

    if (!stickyNav || !sentinel) {
        return;
    }

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (!entry.isIntersecting) {
                stickyNav.classList.add('is-sticky');
            } else {
                stickyNav.classList.remove('is-sticky');
            }
        },
        { threshold: 0 },
    );

    observer.observe(sentinel);
});
